/* ==========================================================================
   Product card — swatch interaction
   Clicking a colour swatch on a product card swaps the card's photo, colour
   label, price and links to the selected colour *in place* instead of
   navigating to that colour's product page. The swatch keeps its href, so with
   JS disabled it still works as a normal link (progressive enhancement).

   Document-level delegation + a global guard means it works for every product
   card on the page regardless of which section rendered it, and is safe to load
   more than once.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__odditProductCardSwatches) return;
  window.__odditProductCardSwatches = true;

  // Find the BEM block's swatch class (e.g. "oddit-product-card__swatch") so we
  // can derive its "--active" modifier without hard-coding the prefix.
  function swatchBaseClass(el) {
    var tokens = (el.className || '').split(/\s+/);
    for (var i = 0; i < tokens.length; i++) {
      if (/__swatch$/.test(tokens[i])) return tokens[i];
    }
    return null;
  }

  function swapImage(img, src) {
    if (!img || !src) return;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.setAttribute('src', src);
  }

  // Derive the "__card-image--model" modifier from an image's base class so the
  // model crop can be toggled without hard-coding the BEM prefix.
  function cardImageModelClass(img) {
    if (!img) return null;
    var tokens = (img.className || '').split(/\s+/);
    for (var i = 0; i < tokens.length; i++) {
      if (/__card-image$/.test(tokens[i])) return tokens[i] + '--model';
    }
    return null;
  }

  function handleClick(e) {
    var swatch = e.target.closest && e.target.closest('[data-swatch]');
    if (!swatch) return;
    var card = swatch.closest('[data-product-card]');
    if (!card) return;

    // Intercept the navigation — swap in place instead.
    e.preventDefault();

    var imageSrc = swatch.getAttribute('data-swatch-image');
    var secondarySrc = swatch.getAttribute('data-swatch-secondary');
    var isModel = swatch.getAttribute('data-swatch-model') === 'true';
    var modelPosition = swatch.getAttribute('data-swatch-model-position');
    var url = swatch.getAttribute('data-swatch-url');
    var color = swatch.getAttribute('data-swatch-color');
    var price = swatch.getAttribute('data-swatch-price');
    var priceVaries = swatch.getAttribute('data-swatch-price-varies') === 'true';
    var compare = swatch.getAttribute('data-swatch-compare');

    var wrap = card.querySelector('[data-card-image-wrap]');
    if (wrap) {
      var imgs = wrap.querySelectorAll('img');
      swapImage(imgs[0], imageSrc);
      if (secondarySrc) swapImage(imgs[1], secondarySrc);

      // BEB-131: keep the model crop in sync with the swapped image.
      var modelCls = cardImageModelClass(imgs[0]);
      if (modelCls && imgs[0]) imgs[0].classList.toggle(modelCls, isModel);
      if (isModel && modelPosition) wrap.style.setProperty('--oddit-model-position', modelPosition);
    }

    if (color != null) {
      var colorEl = card.querySelector('[data-card-color]');
      if (colorEl) {
        colorEl.textContent = color;
        if (color) colorEl.removeAttribute('hidden');
      }
    }

    if (price != null) {
      var amountEl = card.querySelector('[data-card-price-amount]');
      if (amountEl) amountEl.textContent = price;
      var fromEl = card.querySelector('[data-card-price-from]');
      if (fromEl) fromEl.style.display = priceVaries ? '' : 'none';
    }

    // Empty data-swatch-compare means that colour isn't on sale -> hide the slash.
    var compareEl = card.querySelector('[data-card-price-compare]');
    if (compareEl) {
      var compareAmountEl = compareEl.querySelector('[data-card-price-compare-amount]');
      if (compareAmountEl) compareAmountEl.textContent = compare || '';
      compareEl.hidden = !compare;
    }

    if (url) {
      var links = card.querySelectorAll('[data-card-link], [data-card-title-link]');
      Array.prototype.forEach.call(links, function (a) {
        a.setAttribute('href', url);
      });
    }

    // Move the active state to the clicked swatch.
    var base = swatchBaseClass(swatch);
    if (base) {
      var activeMod = base + '--active';
      var group = swatch.parentElement;
      if (group) {
        Array.prototype.forEach.call(group.querySelectorAll('.' + activeMod), function (s) {
          s.classList.remove(activeMod);
          s.removeAttribute('aria-current');
        });
      }
      swatch.classList.add(activeMod);
      swatch.setAttribute('aria-current', 'true');
    }
  }

  document.addEventListener('click', handleClick);
})();
